import * as actions from "./actionsType";

const initialData = {
  loaderEvaluationFactor: false,
  evaluationFactor: null,
  evaluationFactorAll: null,
  evaluationFactorAnio: null,
  evaluationFactorFalla: null,
  saveLoaderEvaluationFactor: false,
  evaluationFactorFormError: null,
};

export default function MetricEvaluationFactorReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_EVALUATION_FACTOR:
      return { ...state, loaderEvaluationFactor: action.payload };

    case actions.GET_EVALUATION_FACTOR:
      return {
        ...state,
        evaluationFactor: action.payload.evaluationFactor,
        evaluationFactorAll: action.payload.evaluationFactorAll,
        evaluationFactorAnio: action.payload.evaluationFactorAnio,
      };

    case actions.GET_EVALUATION_FACTOR_ALL:
      return { ...state, evaluationFactorAll: action.payload };

    case actions.EVALUATION_FACTOR_FALLA:
      return { ...state, evaluationFactorFalla: action.payload };

    case actions.SAVE_LOADER_EVALUATION_FACTOR:
      return { ...state, saveLoaderEvaluationFactor: action.payload };

    case actions.FORM_EVALUATION_FACTOR_FAIL:
      return { ...state, evaluationFactorFormError: action.payload };

    default:
      return state;
  }
}
